import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { BaseComponent } from '../base/base-component.component';

export enum WaitingIndicatorSize {
  Tiny,
  Small,
  Medium,
}

@Component({
  standalone: false,
  selector: 'daui-waiting-indicator',
  templateUrl: './waiting-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./waiting-indicator.component.less'],
})
export class WaitingIndicatorComponent extends BaseComponent {
  @Input() size = WaitingIndicatorSize.Medium;

  readonly waitingIndicatorSize = WaitingIndicatorSize;

  constructor() {
    super();
  }

  onInit() {}
  onDestroy() {}
}
